import { useAuthStore } from '@/stores/auth.ts';

let pulse = null;

export function usePulse() {
  if (pulse) {
    return;
  }

  const authStore = useAuthStore();

  pulse = setInterval(() => {
    authStore.pulse().then();
  }, 120 * 1000);
  authStore.pulse().then();
}
